module.exports = __webpack_public_path__ + "static/media/globe.6b4d5a01.svg";